import { DemandPreviewContainer } from "./container";
import { PageFrame } from "../../components/page_frame";

export const DemandPreviewPage = () => {
  return (
    <PageFrame>
      <DemandPreviewContainer />
    </PageFrame>
  );
};
